import { c as _c } from "react/compiler-runtime";
import Icon from "@/components/icon";
interface ProfilChipProps {
  profil: string;
  onRemove?: () => void;
  isRemoving?: boolean;
  className?: string;
}
export const ProfilChip = t0 => {
  const $ = _c(7);
  const {
    profil,
    onRemove,
    isRemoving,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `bg-member-blue text-white px-3 py-1 [border-radius:8px] text-sm flex items-center gap-2 ${className}`;
  let t3;
  if ($[0] !== isRemoving || $[1] !== onRemove) {
    t3 = onRemove && <button onClick={onRemove} className="hover:text-red-300 disabled:opacity-50" disabled={isRemoving}>{isRemoving ? <Icon icon="time" className="animate-spin" size={12} /> : "\xD7"}</button>;
    $[0] = isRemoving;
    $[1] = onRemove;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== profil || $[4] !== t2 || $[5] !== t3) {
    t4 = <span className={t2}>{profil}{t3}</span>;
    $[3] = profil;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};